/*
 * 数据报告的相关常量
 */

// 单图间距
const GRID_MARGIN = 4

// 筛选器类型
const FILTER_TYPES = [
  'select_filter',
  'select_filter_mobile',
  'number_filter',
  'time_interval_filter',
  'date_interval_filter',
  'date_filter_mobile',
  'checkbox_filter',
  'timeline',
  'tablist',
  'button_filter',
  'search_filter',
  'label_filter',
  'combine_filter'
]

// 地图类型
const AREA_TYPES = [
  'scatter_map',
  'area_map',
  'area_map_heat',
  'area_map_yk',
  'area_map_longitute',
  'label_map',
  'area_province_map', //非内置组件
  'area_map_cure' // 非内置组件
]

// 日期类型
const DATA_TYPES = [
  'date_interval_filter',
  'date_filter_mobile',
  'candlestick'
]

// 简单单图类型
const SIMPLE_TYPES = [
  'simple_text',
  'simple_image',
  'simple_clock',
  'simple_tab',
  'iframe',
  'border_decoration',
  'backdrop'
]

const NONE_NORMAL_TITLE_CHART_TYPE = [
  'numerical_value',
  // 'gauge',
  'split_gauge',
  // 'liquid_fill'
]

const MOBILE_SHOW_TITLE = [
  'numerical_value_mobile',
  'numerical_panel_mobile',
  'flow_bar_mobile',
  'funnel_mobile',
  'multiple_horizon_bar_mobile',
  'multiple_area_mobile',
  'multiple_line_mobile',
]

const CAMPATIBLE_TITLE_CHART_TYPE = ['liquid_fill', 'tab_mobile']

// 不可选中升级层级的单图
const NONE_ZINDEX = [
  'backdrop',
  'border_decoration',
  'simple_image',
  'simple_clock',
  'simple_text',
  'simple_image_zoom'
]

const HAS_DATA_TABLE_CHART_TYPE = [
  'pie'
]

export { GRID_MARGIN, FILTER_TYPES, AREA_TYPES, DATA_TYPES, SIMPLE_TYPES, NONE_NORMAL_TITLE_CHART_TYPE, CAMPATIBLE_TITLE_CHART_TYPE, NONE_ZINDEX, MOBILE_SHOW_TITLE, HAS_DATA_TABLE_CHART_TYPE }
